// removed by extract-text-webpack-plugin
module.exports = {"container":"h1_g","button":"h1_bp _1kB_d9laDuyaX1azPOvneD"};


//////////////////
// WEBPACK FOOTER
// ./app/src/components/ReadMore/styles.module.css
// module id = 1178
// module chunks = 27